import React from 'react';
import { useStyles } from './Score.styles';
import DisabledBadge from '../DisabledBadge/DisabledBadge.component';
import TooltipOne from '../TooltipOne/TooltipOne.component';

interface ScoreProps {
  score: number;
  isActive: boolean;
  disabled?: boolean;
  onClick: (score: number) => void;
}

export const Score: React.FC<ScoreProps> = (props) => {
  const classes = useStyles();

  return (
    <TooltipOne
      placement="top"
      title={
        props.disabled
          ? 'To kryterium należy oceniać używając adnotacji do oceny zdefiniowanych w pasku narzędzi z adnotacjami'
          : ''
      }
    >
      <span>
        <DisabledBadge badgeHidden={!props.disabled}>
          <div
            className={[
              classes.score,
              props.disabled ? classes.disabledScore : classes.enabledScore,
              props.isActive ? (props.disabled ? classes.disabledActiveScore : classes.activeScore) : '',
            ].join(' ')}
            onClick={props.disabled ? undefined : () => props.onClick(props.score)}
          >
            {props.score}
          </div>
        </DisabledBadge>
      </span>
    </TooltipOne>
  );
};
